// menu-desktop.js 			~/js/
////////////////////////////////////////////////////////////

const header = document.querySelector('.header-main');
const menuItems = document.querySelectorAll('.main-nav .menu li');
const subMenus = document.querySelectorAll('.submenu-desktop');

// Find all links
menuItems.forEach((menuItem) => {
  let menuID = menuItem.textContent.trim();
  menuID = menuID.replace(/\s+/g, '-');
  const subMenuID = document.querySelector('.submenu-desktop.sub-' + menuID);

  // Clear everything if mouse enters any menu item except if it is already active
  if (menuItem) {
    menuItem.addEventListener('mouseover', () => {
      if (!menuItem.classList.contains('is-active')) {
        menuItems.forEach((menuItem) => {
          header.classList.remove('menu-active');
          menuItem.classList.remove('is-active');
          subMenus.forEach((submenu) => submenu.classList.remove('is-active'));
        });
      }
    });
  }

  // Add .menu-active to header and .is-active to menu-items
  // that have submenus if mouse enters item with submenu
  if (menuItem && subMenuID) {
    menuItem.addEventListener('mouseover', () => {
      header.classList.add('menu-active');
      menuItem.classList.add('is-active');
      subMenuID.classList.add('is-active');
    });
  }
});

// Clear everything when mouse leaves the header
header.addEventListener('mouseleave', () => {
  header.classList.remove('menu-active');
  menuItems.forEach((menuItem) => menuItem.classList.remove('is-active'));
  subMenus.forEach((submenu) => submenu.classList.remove('is-active'));
});
